import React, { useEffect, useRef } from 'react';
import { Empty, Spin } from 'antd';
import CommentBlock from '../CommentBlock';
import styles from './index.module.scss';

const ModalBody = ({ data, isLoading, isAuthor, canEditComment = true }) => {
  const hasMessages = Array.isArray(data) && data.length > 0;

  return (
    <Scroller>
      <ul className={styles.messages}>
        {hasMessages ? (
          data.map((comment) => (
            <li key={comment.id}>
              <CommentBlock
                comment={comment}
                isAuthor={isAuthor(comment)}
                canEditComment={canEditComment}
              />
            </li>
          ))
        ) : (
          <li>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Нет комментариев"
            />
          </li>
        )}
      </ul>
      <Spin spinning={isLoading} className={styles.spin} />
    </Scroller>
  );
};

export default ModalBody;

function Scroller({ children }) {
  const rootRef = useRef();
  const innerRef = useRef();

  useEffect(() => {
    if (!rootRef.current) return;

    const root = rootRef.current;
    const inner = innerRef.current;

    const observer = new ResizeObserver(() => {
      root.scrollTop = root.scrollHeight;
    });

    observer.observe(inner);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={rootRef} className={styles.root}>
      <div ref={innerRef}>{children}</div>
    </div>
  );
}
